import { Helmet } from "react-helmet-async";
import { buildCanonicalUrl, normalizePathname } from "../../lib/seo";

export default function Seo({
  title,
  metaTitle,
  description,
  canonicalPath,
  canonicalUrl,
  schema,
  image,
  type = "website",
}) {
  const resolvedTitle = metaTitle || title;
  const resolvedCanonical =
    canonicalUrl || (canonicalPath ? buildCanonicalUrl(canonicalPath) : "");
  const normalizedSchema = schema ? (Array.isArray(schema) ? schema : [schema]) : [];

  return (
    <Helmet>
      {resolvedTitle ? <title>{resolvedTitle}</title> : null}
      {resolvedTitle ? <meta property="og:title" content={resolvedTitle} /> : null}
      {description ? <meta name="description" content={description} /> : null}
      {description ? <meta property="og:description" content={description} /> : null}
      {resolvedCanonical ? <link rel="canonical" href={resolvedCanonical} /> : null}
      {resolvedCanonical ? <meta property="og:url" content={resolvedCanonical} /> : null}
      <meta property="og:type" content={type} />
      {image ? <meta property="og:image" content={image} /> : null}
      {image ? <meta name="twitter:image" content={image} /> : null}
      {resolvedTitle ? <meta name="twitter:title" content={resolvedTitle} /> : null}
      {description ? <meta name="twitter:description" content={description} /> : null}
      {normalizedSchema.map((item, index) => {
        const content = typeof item === "string" ? item : JSON.stringify(item);
        return (
          <script
            key={`${normalizePathname(canonicalPath || "/")}-${index}`}
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: content }}
          />
        );
      })}
    </Helmet>
  );
}
